import { INIT_FETCH_DATA, SUCCESS_FETCH_ROI_DATA, ERROR, HANDLE_SLIDE_CHANGE, ON_RANGE_CHANGE, APPLY_FILTER, RESET_PUSH_UPDATES, UPDATE_CANAVAS_IMAGE_DATA, ON_ENTRY_FILTER_CHANGE } from "../../types";
import { deepClone, formatFinalData, setContestsData, getFromStorage, updateStorage, getMatch, clearROICacheByMatchCode, clearROICache, startHTTPRequest } from "../../../assets/js/common";
import { FG_DEFAULT_PLATFORMS } from "../../../assets/js/config";

const setContestsDataMutation = (state) => {
    let {
        allDataOfTheMatch,
        initialStepValue,
        filters,
        entry_fee_filter,
    } = state;

    let standingsData = formatFinalData(
        deepClone(allDataOfTheMatch)
    );

    if(!filters.filter_applied && !filters.platforms.length && allDataOfTheMatch.Platforms && allDataOfTheMatch.Platforms.length) {
        let ids = [];
        allDataOfTheMatch.Platforms.map(p => {
            let pName = p.pn.toLowerCase();
            if(FG_DEFAULT_PLATFORMS.includes(pName)) {
                ids.push(p.pid);
            }
        })
        if(ids && ids.length) {
            filters.platforms = ids;
            filters.filter_applied = true;
        }
    }

    let { contests, filter_options } = setContestsData({
        standingsData,
        initialStepValue,
        filters,
        entry_fee_filter,
    });

    state.contest_count = contests.length;
    if (typeof window === "undefined") contests = contests.slice(0, 20);
    state.selectedMatchContests = contests;
    state.filter_options = filter_options;
    state.reset_scroll = !state.reset_scroll;
    state.isLoading = false;
    return state;
};

const contest_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.contest_store) ? window.__ROI_STATE_DATA__.contest_store : {
        page: 'Contest page',
        contest_store_filled: false,
        isLoading: true,
        is_initial_request: undefined, //can be undefined , number(after first request) and boolean (after second request)
        selectedMatchContests: [],
        allDataOfTheMatch: {},
        initialStepValue: 1, //1 to 13. for null value it will automatically apply center position in slider
        entry_fee_filter: [
            { range: [1, 300], is_selected: true },
            { range: [301, 999], is_selected: false },
            { range: [1000, "{{max}}"], is_selected: false },
            { range: ["{{min}}", "{{max}}"], is_selected: false },
        ],
        filters: {
            price_pool: [0, 0],
            spots: [0, 0],
            platforms: [],
            filter_applied: false,
            sort_by: {
                prop: "ar",
                order: "desc",
            },
        },
        filter_options: {
            entry_fee_slider: [0, 0],
            total_price_slider: [0, 0],
            total_spots_slider: [0, 0],
        },
        reset_scroll: false,
        can_update: true,
        contests_updated: false,
        is_polling: false,
        element_config: {
            apply: false,
            newLeft: 0,
        },
        slicedData2: [],
        slicedData: [],
        contest_count: 0,
    }),
    actions: {
        fetchROIdata: ({ commit, state, rootState, dispatch }, { slug }) => {
            let { route, match_detail_store } = rootState;
            let level = route.query && route.query.level;

            if (match_detail_store.no_matches_active) return;

            commit(INIT_FETCH_DATA);
            let match = getMatch(match_detail_store.match_data, "slug", slug);
            let match_code = match.code;
            let match_guid = match.id;

            dispatch(
                "match_detail_store/updateMatchState",
                {
                    code: match_code,
                    match_loaded: typeof match_detail_store.is_initial_request === "undefined", //first time no shimmer; ssr->frotend first call
                },
                {
                    root: true,
                }
            );

            /**
             * on client side initial ROI data fetch is requested by
             * route change event and front end check auth flow
             * so using `is_initial_request` as decider
             * on ssr is_initial_request is undefined
             * after first request is_initial_request is number cuz of route change call
             * and here for second time chekcing if number and making boolean after authflow call
             * currently boolean part not in use
             */

            //after first request done form frontend , fill in the value
            typeof window !== "undefined" &&
                (match_detail_store.is_initial_request = Date.now());

            if (getFromStorage(`roi:${match.version}:${match.code}`)) {
                dispatch(
                    "match_detail_store/updateMatchState",
                    {
                        code: match_code,
                        match_loaded: true,
                    },
                    {
                        root: true,
                    }
                );
                let data = JSON.parse(
                    getFromStorage(`roi:${match.version}:${match.code}`)
                );
                data.level = level;
                commit(SUCCESS_FETCH_ROI_DATA, data);
                return;
            }

            return startHTTPRequest({
                method: "GET",
                url: `api/App/ContestROI`,
                params: {
                    match_code: match_guid,
                },
            })
                .then((res) => {
                    if (res) {
                        let data = deepClone(res);
                        data.level = level;
                        commit(SUCCESS_FETCH_ROI_DATA, data);
                        dispatch(
                            "match_detail_store/updateMatchState",
                            {
                                code: match_code,
                                match_loaded: true,
                            },
                            {
                                root: true,
                            }
                        );
                        if (typeof window !== "undefined") {
                            clearROICacheByMatchCode({
                                code: match.code,
                            });
                            updateStorage(
                                `roi:${match.version}:${match.code}`,
                                JSON.stringify(res)
                            );
                        }
                    } else {
                        console.log("API ERROR---->");
                        commit(ERROR);
                    }
                })
                .catch((e) => {
                    console.log(e);
                    commit(ERROR);
                });
        },
        matchDataUpdatePolling: ({ state, dispatch, rootState }) => {
            let { match_detail_store } = rootState;
            return startHTTPRequest({
                method: "GET",
                url: `api/App/GetMatches`,
            })
                .then((res) => {
                    let { matches, version, categories } = res;
                    matches = matches.filter(m => m.show_in_fe);
                    categories = categories.filter(c => {
                        let hasMatchAvailable = matches.find(m => (m.category_id == c.category_id && m.show_in_fe))
                        return hasMatchAvailable;
                    })
                    let cached_match_version = getFromStorage("match_version");

                    if (+cached_match_version !== version) {
                        updateStorage("match_version", version);
                        match_detail_store.match_api_version = version;
                        let current_match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
                        let match_from_polling = getMatch(matches, "slug", match_detail_store.slug);

                        if ( current_match.version !== match_from_polling.version && state.can_update ) {
                            state.contests_updated = true;
                            for (let cat in match_detail_store.match_data) {
                                for ( let i = 0; i < match_detail_store.match_data[cat].length; i++ ) {
                                    if ( match_detail_store.match_data[cat][i].code === current_match.code ) {
                                        match_detail_store.match_data[cat][i].version = match_from_polling.version;
                                    }
                                }
                            }
                        }
                    }
                    clearROICache(matches);
                    return dispatch("match_detail_store/updateRootMatchData", { ...res, matches: matches, categories: categories}, { root: true });
                });
        },
        applyFilter: ({ commit }, payload) => {
            return commit(APPLY_FILTER, payload);
        },
        rangeChange: ({ commit }, payload) => {
            return commit(ON_RANGE_CHANGE, payload);
        },
        // slideChange: ({ commit, rootState }, payload) => {
        //     let { match_detail_store } = rootState;
        //     match_detail_store.slug = payload.slug;
        //     return commit(HANDLE_SLIDE_CHANGE, payload);
        // },
        resetPushUpdate: ({ commit }) => {
            return commit(RESET_PUSH_UPDATES);
        },
        updateCanvasData: ({ commit }, payload) => {
            return commit(UPDATE_CANAVAS_IMAGE_DATA, payload);
        },
        resetFilter: ({ state }) => {
            state.filters = {
                entry_fee: [0, 0],
                price_pool: [0, 0],
                spots: [0, 0],
                platforms: [],
                filter_applied: false,
                sort_by: {
                    prop: "ar",
                    order: "desc",
                },
            };
        },
        applyEntryFeeFilter: ({ commit }, payload) => {
            return commit(ON_ENTRY_FILTER_CHANGE, payload);
        },
    },
    mutations: {
        [INIT_FETCH_DATA]: (state) => {
            return (state.isLoading = true);
        },
        [SUCCESS_FETCH_ROI_DATA]: (state, payload) => {
            state.contest_store_filled = true;
            state.allDataOfTheMatch = payload;
            if (typeof state.initialStepValue === "undefined") {
                let standingsp = payload.standings.map((s) => +s.standingp);
                state.initialStepValue =
                    standingsp[Math.round((standingsp.length - 1) / 2)];
                if (payload.level && standingsp.includes(+payload.level))
                    state.initialStepValue = +payload.level;
            }
            setContestsDataMutation(state);
            if (typeof window === "undefined") state.allDataOfTheMatch = {};
        },
        [ERROR]: (state) => {
            state.contest_store_filled = true;
            return (state.isLoading = false);
        },
        [HANDLE_SLIDE_CHANGE]: (state) => {
            state.reset_scroll = !state.reset_scroll;
        },
        [ON_RANGE_CHANGE]: (state, payload) => {
            state.element_config = payload.element_config;
            state.initialStepValue = payload.stepVal;
            setContestsDataMutation(state);
        },
        [APPLY_FILTER]: (state, payload) => {
            state.filters = payload;
            setContestsDataMutation(state);
        },
        [RESET_PUSH_UPDATES]: (state) => {
            state.contests_updated = false;
        },
        [UPDATE_CANAVAS_IMAGE_DATA]: (state, payload) => {
            if (payload.type === 1) {
                state.slicedData = payload.data;
            } else {
                state.slicedData2 = payload.data;
            }
        },
        [ON_ENTRY_FILTER_CHANGE]: (state, payload) => {
            state.entry_fee_filter.forEach((level, index) => {
                level.is_selected = index === payload.level;
            });
            setContestsDataMutation(state);
        },
    }
}

export default contest_store;